import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import moment from "moment";

const UserDetails = () => {
  const { state } = useLocation();
  const navigate = useNavigate();
  const user = state?.user;

  if (!user) {
    return (
      <div className="p-6">
        <p className="text-red-500 font-semibold">
          No user data passed. Try clicking from the user list.
        </p>
        <button
          onClick={() => navigate(-1)}
          className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
        >
          Go Back
        </button>
      </div>
    );
  }

  const { onBoardingDetails, history } = user || {};

  const countWithAlcohol = history?.filter((entry) =>
    entry.includes("Restaurant w/Alcohol")
  ).length;
  const countWithoutAlcohol = history?.filter((entry) =>
    entry.includes("Restaurant w/o Alcohol")
  ).length;

  const {
    withAlcoholNumber = 0,
    withoutAlcoholNumber = 0,
    items = [],
    type,
    VenuesCount = 0,
  } = onBoardingDetails || {};

  const adjustedWithAlcoholNumber =
    Number(withAlcoholNumber) - Number(countWithAlcohol);
  const adjustedWithoutAlcoholNumber =
    Number(withoutAlcoholNumber) - Number(countWithoutAlcohol);

  let rateWithAlcohol = 0;
  if (adjustedWithAlcoholNumber === 1) rateWithAlcohol = 1500;
  else if (adjustedWithAlcoholNumber >= 2 && adjustedWithAlcoholNumber <= 5)
    rateWithAlcohol = 1300;
  else if (adjustedWithAlcoholNumber > 5) rateWithAlcohol = 1200;

  let rateWithoutAlcohol = 0;
  if (adjustedWithoutAlcoholNumber === 1) rateWithoutAlcohol = 1000;
  else if (adjustedWithoutAlcoholNumber >= 2 && adjustedWithoutAlcoholNumber <= 5)
    rateWithoutAlcohol = 900;
  else if (adjustedWithoutAlcoholNumber > 5) rateWithoutAlcohol = 800;

  let totalItems = 0;
  const visibleItems = items?.filter((item) => {
    const itemName = item.answer === "yes" ? "Multi Venue" : "Unique Venue";
    return !history?.some(
      (h) => h.includes(itemName) || itemName.includes(h)
    );
  }) || [];

  if (
    onBoardingDetails?.selectedChips?.length === 1 &&
    onBoardingDetails?.selectedChips[0] === "Kids Play Area"
  ) {
    totalItems = visibleItems.reduce((acc, item) => acc + 1000 * item.amount, 0);
  } else {
    totalItems = visibleItems.reduce((acc, item) => {
      const rate = item.answer === "yes" ? 2000 : 1000;
      return acc + rate * item.amount;
    }, 0);
  }

  let hotelStaysTotal = 0;
  if (type === "HotelStayandVenue") {
    hotelStaysTotal = 2000;
  }

  const totalWithAlcohol = rateWithAlcohol * adjustedWithAlcoholNumber;
  const totalWithoutAlcohol = rateWithoutAlcohol * adjustedWithoutAlcoholNumber;
  const subTotal = totalWithAlcohol + totalWithoutAlcohol + totalItems + hotelStaysTotal;
  const vat = subTotal * 0.05;
  const discountPercentage = user?.specialDiscount || 0;
  const discountAmount = (subTotal + vat) * (discountPercentage / 100);
  const grandTotal = subTotal + vat - discountAmount;

  return (
    <div className="p-6 max-w-4xl mx-auto font-outfit bg-white rounded-md shadow-md">
      <h2 className="text-2xl font-bold mb-4">User Details</h2>
      <div className="grid grid-cols-2 gap-4 mb-6 text-sm text-gray-700">
        <p><strong>Name:</strong> {user.fullName}</p>
        <p><strong>Email:</strong> {user.email}</p>
        <p><strong>Phone:</strong> {user.mobileNumber || "--"}</p>
        <p><strong>Type:</strong> {user.type}</p>
        <p><strong>LastUsed:</strong> {user.date ? moment(user.date).format("DD-MM-YYYY") : "--"}</p>
      </div>

      <div className="border-t pt-6">
        <h3 className="text-[32px] font-bold mb-2">Venue Plan <span className="text-[16px] text-gray-500 font-normal">/ Annum</span></h3>

        <div className="grid grid-cols-4 text-sm font-medium text-gray-800 border-b pb-2">
          <span>Plan Breakdown</span>
          <span className="text-center">Rate</span>
          <span className="text-center">Quantity</span>
          <span className="text-right">Total</span>
        </div>

        <div className="grid grid-cols-4 py-3 items-center text-gray-700">
          <span>Restaurants w/ Alcohol</span>
          <span className="text-center">${rateWithAlcohol}</span>
          <div className="text-center border w-11 mx-auto py-0.5 rounded text-sm">
            {adjustedWithAlcoholNumber}
          </div>
          <span className="text-right">${totalWithAlcohol}</span>
        </div>

        <div className="grid grid-cols-4 py-3 items-center text-gray-700">
          <span>Restaurants w/o alcohol</span>
          <span className="text-center">${rateWithoutAlcohol}</span>
          <div className="text-center border w-11 mx-auto py-0.5 rounded text-sm">
            {adjustedWithoutAlcoholNumber}
          </div>
          <span className="text-right">${totalWithoutAlcohol}</span>
        </div>

        {visibleItems.map((item, i) => {
          const label = item.answer === "yes" ? "Multi Venue" : "Unique Venue";
          const rate =
            onBoardingDetails?.selectedChips?.length === 1 &&
            onBoardingDetails?.selectedChips[0] === "Kids Play Area"
              ? 1000
              : item.answer === "yes"
              ? 2000
              : 1000;
          return (
            <div className="grid grid-cols-4 py-3 items-center text-gray-700" key={i}>
              <span>{label}</span>
              <span className="text-center">${rate}</span>
              <div className="text-center border w-11 mx-auto py-0.5 rounded text-sm">
                {item.amount}
              </div>
              <span className="text-right">${rate * item.amount}</span>
            </div>
          );
        })}

        {type === "HotelStayandVenue" && (
          <div className="grid grid-cols-4 py-3 items-center text-gray-700">
            <span>Hotel + Stays</span>
            <span className="text-center">$2000</span>
            <div className="text-center border w-11 mx-auto py-0.5 rounded text-sm">
              1
            </div>
            <span className="text-right">$2000</span>
          </div>
        )}

        {type === "HotelStayandVenue" && (
          <div className="grid grid-cols-4 py-3 items-center text-gray-700">
            <span>Venues (Free)</span>
            <span className="text-center">0</span>
            <div className="text-center border w-11 mx-auto py-0.5 rounded text-sm">
              {VenuesCount}
            </div>
            <span className="text-right">$0</span>
          </div>
        )}

        <hr className="my-4" />

        <div className="flex justify-between text-sm text-gray-600 mb-1">
          <span>Sub Total</span>
          <span>${subTotal.toFixed(2)}</span>
        </div>
        <div className="flex justify-between text-sm text-gray-600 mb-1">
          <span>VAT service fee (5%)</span>
          <span>${vat.toFixed(2)}</span>
        </div>
        {discountPercentage > 0 && (
          <div className="flex justify-between text-sm text-gray-600 mb-1">
            <span>Discount</span>
            <span>{discountPercentage}%</span>
          </div>
        )}

        <div className="border-t my-4" />

        <div className="flex justify-between text-lg font-bold text-black">
          <span>Grand Total</span>
          <span>${Math.round(grandTotal)} <span className="text-gray-400 text-base font-normal">/year</span></span>
        </div>

        <div className="flex flex-col md:flex-row justify-between mt-4 text-xs text-gray-500">
          <p>
            Enjoy a zero-dollar payment today till{" "}
            {moment(user?.trialEnd).format("MMMM D, YYYY")}, with your
            subscription starting after 6 months.
          </p>
          <p className="font-medium text-black mt-2 md:mt-0">Pay now: $0</p>
        </div>
      </div>
    </div>
  );
};

export default UserDetails;
